(function () {
  function applyCta() {
    const candidates = document.querySelectorAll(
      'header a, header summary, .header a, .header summary'
    );

    candidates.forEach((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

      // Nur der Oberpunkt „Reparatur einleiten“
      if (text === 'reparatur einleiten' || text.startsWith('reparatur einleiten')) {
        el.classList.add('imed-nav-cta');
        if (getComputedStyle(el).display === 'inline') {
          el.style.display = 'inline-flex';
        }
      }
    });
  }

  applyCta();
  document.addEventListener('DOMContentLoaded', applyCta);
  window.addEventListener('load', applyCta);
})();
